import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.25 2.04297H2V7.29297L7.25 7.29297V2.04297ZM9.25 2.04297V7.29297H14.75V2.04297H9.25ZM16.75 2.04297V7.29297L22 7.29297V2.04297H16.75ZM22 9.29297L16.75 9.29297V14.793H22V9.29297ZM22 16.793H16.75V22.043H22V16.793ZM14.75 22.043V16.793L9.25 16.793V22.043H14.75ZM7.25 22.043V16.793H2V22.043H7.25ZM2 14.793H7.25V9.29297L2 9.29297V14.793ZM9.25 14.793V9.29297L14.75 9.29297V14.793L9.25 14.793Z"}}]};

const ComponentGridFilled = Vue.extend<IconProps>({
  name: 'ComponentGridFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'component-grid-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ComponentGridFilled;
